namespace TabAurous.Stock {
    export interface JobTransactionRow {
        StockId?: number;
        TransId?: number;
        MovementId?: number;
        RefTransId?: number;
        VoucherDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        LedgerName?: string;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        RefNo?: string;
        GroupId?: string;
        ItemTypeId?: number;
        HSN?: string;
        ProductId?: number;
        ProductCode?: string;
        AttributeId?: number;
        Attribute?: string;
        ItemType?: string;
        StoneStatusId?: number;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        Rate?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        IsCustomerItem?: boolean;
        Variance?: number;
        PointerWeight?: number;
        CostMethod?: string;
        ImageName?: string;
        CompanyId?: number;
        FinancialYearId?: number;
        Purity?: number;
        PureWeight?: number;
        ProductTypeId?: number;
        StoneColorId?: number;
        MetalColorId?: number;
        QualityId?: number;
        KaratId?: number;
        ShapeId?: number;
        StoneSizeId?: number;
        SieveId?: number;
        MetalCode?: string;
        KaratCode?: string;
        ProductTypeCode?: string;
        Status?: string;
    }

    export namespace JobTransactionRow {
        export const idProperty = 'StockId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Stock.JobTransaction';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            StockId = "StockId",
            TransId = "TransId",
            MovementId = "MovementId",
            RefTransId = "RefTransId",
            VoucherDate = "VoucherDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            RefNo = "RefNo",
            GroupId = "GroupId",
            ItemTypeId = "ItemTypeId",
            HSN = "HSN",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            ItemType = "ItemType",
            StoneStatusId = "StoneStatusId",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            Rate = "Rate",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            IsCustomerItem = "IsCustomerItem",
            Variance = "Variance",
            PointerWeight = "PointerWeight",
            CostMethod = "CostMethod",
            ImageName = "ImageName",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            Purity = "Purity",
            PureWeight = "PureWeight",
            ProductTypeId = "ProductTypeId",
            StoneColorId = "StoneColorId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            KaratId = "KaratId",
            ShapeId = "ShapeId",
            StoneSizeId = "StoneSizeId",
            SieveId = "SieveId",
            MetalCode = "MetalCode",
            KaratCode = "KaratCode",
            ProductTypeCode = "ProductTypeCode",
            Status = "Status"
        }
    }
}
